import React from 'react';

const TeacherAssistantsx4 = ({ className = '' }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      x="0"
      y="0"
      viewBox="0 0 74 74"
    >
      <circle r="37" cx="37" cy="37" fill="#eae9f8" shape="circle" />
      <g transform="matrix(0.68,0,0,0.68,11.84,11.839359741210924)">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M17.965,44.271a.95.95,0,0,1-.2-.02,1,1,0,0,1-.784-1.177l3.2-15.894a1,1,0,0,1,.98-.8H52.844a1,1,0,0,1,.98.8l3.2,15.884a1,1,0,0,1-1.961.395L52.025,28.377H21.984l-3.04,15.091A1,1,0,0,1,17.965,44.271Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M28.619,63.028H14.182a1,1,0,0,1-.981-1.2l2.365-11.713a1,1,0,0,1,1.961.4L15.4,61.028H28.619a1,1,0,0,1,0,2Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M59.828,63.028H45.381a1,1,0,0,1,0-2H58.606L56.482,50.513a1,1,0,0,1,1.961-.4L60.809,61.83a1,1,0,0,1-.981,1.2Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M46.548,28.377a1,1,0,0,1-1-1v-.359a5.257,5.257,0,0,0-5.255-5.246H33.707a5.257,5.257,0,0,0-5.255,5.246v.359a1,1,0,0,1-2,0v-.359a7.259,7.259,0,0,1,7.255-7.246h6.586a7.259,7.259,0,0,1,7.255,7.246v.359A1,1,0,0,1,46.548,28.377Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M37,18a5.656,5.656,0,1,1,5.656-5.656A5.662,5.662,0,0,1,37,18Zm0-9.312a3.656,3.656,0,1,0,3.656,3.656A3.66,3.66,0,0,0,37,8.692Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M20.467,51.318H3a1,1,0,0,1-1-1V48a6.728,6.728,0,0,1,6.72-6.72h6.027A6.728,6.728,0,0,1,21.467,48v2.321A1,1,0,0,1,20.467,51.318ZM4,49.318H19.467V48a4.725,4.725,0,0,0-4.72-4.72H8.72A4.725,4.725,0,0,0,4,48Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M11.733,39.829a5.261,5.261,0,1,1,5.261-5.261A5.267,5.267,0,0,1,11.733,39.829Zm0-8.522a3.261,3.261,0,1,0,3.261,3.261A3.265,3.265,0,0,0,11.733,31.307Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M71,51.318H53.533a1,1,0,0,1-1-1V48a6.728,6.728,0,0,1,6.72-6.72H65.28A6.728,6.728,0,0,1,72,48v2.321A1,1,0,0,1,71,51.318Zm-16.467-2H70V48a4.725,4.725,0,0,0-4.72-4.72H59.253A4.725,4.725,0,0,0,54.533,48Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M62.267,39.829a5.261,5.261,0,1,1,5.26-5.261A5.267,5.267,0,0,1,62.267,39.829Zm0-8.522a3.261,3.261,0,1,0,3.26,3.261A3.265,3.265,0,0,0,62.267,31.307Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M45.733,67.308H28.267a1,1,0,0,1-1-1V63.987a6.726,6.726,0,0,1,6.719-6.719h6.028a6.726,6.726,0,0,1,6.719,6.719v2.321A1,1,0,0,1,45.733,67.308Zm-16.466-2H44.733V63.987a4.724,4.724,0,0,0-4.719-4.719H33.986a4.724,4.724,0,0,0-4.719,4.719Z"
          fill="#5c48d3"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M37,55.819a5.261,5.261,0,1,1,5.261-5.261A5.268,5.268,0,0,1,37,55.819ZM37,47.3a3.261,3.261,0,1,0,3.261,3.261A3.265,3.265,0,0,0,37,47.3Z"
          fill="#5c48d3"
        />
      </g>
    </svg>
  );
};
export default TeacherAssistantsx4;
